var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.showing == "react"
    ? _c(
        "div",
        {
          staticClass: "code-snippet-tab",
          attrs: {
            id: "code-snippet-react",
            role: "tabpanel",
            "aria-labelledby": "tab-react",
          },
        },
        [
          _vm.majorVersion !== 5
            ? _c("div", { staticClass: "padding-top-sm padding-x-xl" }, [
                _c(
                  "ul",
                  {
                    staticClass:
                      "code-snippet-secondary-tabs size-sm position-relative z-1",
                    staticStyle: {
                      "--list-style-type": "none",
                      "--padding-left": "0",
                      "--margin-bottom": "0",
                      "--button-padding":
                        "var(--spacing-2xs) var(--spacing-sm)",
                      "--button-border-radius": "0",
                      "--button-margin-bottom": "0",
                    },
                    attrs: { role: "tablist" },
                  },
                  _vm._l(_vm.filteredOptions, function (option) {
                    return _c(
                      "li",
                      {
                        key: option.value,
                        staticStyle: { "--display": "inline-block" },
                        attrs: { role: "presentation" },
                      },
                      [
                        _c(
                          "button",
                          {
                            staticClass:
                              "link flat block code-snippet-secondary-tab",
                            staticStyle: {
                              "--button-active-background": "transparent",
                            },
                            attrs: {
                              id: `tab-${option.value}`,
                              type: "button",
                              role: "tab",
                              "aria-controls": `${option.value}`,
                              "aria-selected":
                                _vm.syntaxChoice === option.value
                                  ? "true"
                                  : "false",
                            },
                            on: {
                              click: function ($event) {
                                return _vm.handleSnippetOption(option.value)
                              },
                            },
                          },
                          [
                            _vm._v(
                              "\n          " +
                                _vm._s(option.label) +
                                "\n        "
                            ),
                          ]
                        ),
                      ]
                    )
                  }),
                  0
                ),
              ])
            : _vm._e(),
          _vm._v(" "),
          _c("wa-code-block", {
            attrs: {
              "add-highlighting": "",
              "allow-shadow-copy": "",
              "copy-text": "Go to React Docs",
              "copy-tracking-event": "icon_react_code_copy_button_click",
              "copy-tracking-params": {
                icon_name: _vm.icon.name,
                icon_style: _vm.styling.style,
                icon_family: _vm.styling.family,
              },
              "custom-copy-icon": "faClone",
              lang: "jsx",
              code: _vm.codeSnippet,
            },
            nativeOn: {
              click: function ($event) {
                return _vm.$emit("copyReact")
              },
            },
          }),
          _vm._v(" "),
          _c("icon-code-snippet-links", {
            attrs: {
              "has-custom-styling": _vm.hasCustomStyling,
              links: _vm.reactLearnAboutLinks,
              "selected-style": _vm.styling.style,
              "major-version": _vm.majorVersion,
            },
          }),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }